























import { Vue, Component } from 'vue-property-decorator';

import { OnlineOnboardingURL } from '@/views/Onboarding/helpers';
import { getOauthState } from '@/router/router-utils';
import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import YourStore from './YourStore.vue';

let timer: NodeJS.Timeout;

@Component({
  components: {
    TwismLogoIcon,
    YourStore
  }
})
export default class LoadingOnboarding extends Vue {
  oauthState = getOauthState();

  finishedAnimation = false;

  get name() {
    if (!this.oauthState) return 'Merchant';
    return this.oauthState.businessData.name;
  }

  created() {
    this.$hideLoader();
    timer = setTimeout(() => {
      this.finishedAnimation = true;
      setTimeout(() => {
        this.$router.push(OnlineOnboardingURL.YOUR_BUSINESS);
      }, 1000);
    }, 2000);
  }

  beforeDestroy() {
    clearInterval(timer);
  }
}
